.btn {
  display: inline-grid;
  place-items: center;
  border: 1.5px solid transparent;
  background: transparent;
  color: var(--color-text-muted);
  border-radius: var(--radius-md);
  cursor: pointer;
  flex: none;
  transition: background 0.15s var(--ease), color 0.15s var(--ease);
}
.btn:hover:not(:disabled) {
  background: var(--color-neutral-soft);
  color: var(--color-text);
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.md {
  width: 40px;
  height: 40px;
}
.sm {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
}
.secondary {
  border-color: var(--color-border-strong);
  background: var(--color-surface);
}
